
import { defineComponent } from "vue";

export default defineComponent({
  name: "IconButton",

  props: {
    icon: {
      type: String,
      required: true
    },

    iconType: {
      type: String,
      default: "fas",
      required: false
    },

    width: {
      type: String,
      default: "30px",
      required: false
    },

    height: {
      type: String,
      default: "30px",
      required: false
    }
  },

  computed: {
    iconSize(): string {
      return `width: ${this.width}; height: ${this.height};`;
    }
  }
});
